export default "__VITE_ASSET__BVsJingV__"